import React from "react";
import { Col, Container as GridContainer, Row } from "react-native-flex-grid";
import { useDeleteCatalogueByIdMutation, useDeleteTemplateByIdMutation, useGetCatalogueQuery, useGetTemplateQuery } from "store/abcoApi";

import { useToken } from "@gluestack-style/react";
import TreeGroupNodeWithPermissions from "components/admin/TreeGroupNodeWithPermissions";
import PageLoader from "components/general/PageLoader";
import { Tab, TabContainer } from "components/general/Tabs";
import Pagination from "components/navigation/Pagination";
import { Box, HStack, Link, Text } from "components/ui";
import { AtSign, Info, Trash2, BookText } from "lucide-react-native";
import { useIsMobile } from "utils/hooks/useIsMobile";

import Seo from "components/general/Seo";
import { Pressable } from "react-native";
import PressableArea from "components/ui/PressableArea";
import StockCollectionListingScreen from "screens/StockCollectionListingScreen";
export default function Page() {
	const [pageNumber, setPageNumber] = React.useState(1);

	const { data, isLoading, isFetching } = useGetTemplateQuery({ pageNumber });
	const [deleteCatalogue] = useDeleteTemplateByIdMutation();

	if (isLoading || data == null) {
		return (
			<Box borderRadius={16} minHeight={500}>
				<PageLoader />
			</Box>
		);
	}

	return (
		<Box>
			<Seo title="Admin | Stocklists | Abconet" description="Manage and update stock lists for inventory management and reporting." />
			<StockCollectionListingScreen isAdmin data={data} deleteCatalogue={deleteCatalogue} setPageNumber={setPageNumber} type="stocklists" />
		</Box>
	);
}
